import { BidiModule } from "@angular/cdk/bidi";
import { PortalModule } from "@angular/cdk/portal";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { NzNoAnimationModule } from "ng-zorro-antd/core/no-animation";
import { NzOutletModule } from "ng-zorro-antd/core/outlet";
import { LocalizationModule } from "@webapp/localization/localization.module";
import { UiAccessibilityModule } from "../accessibility/accessibility.module";
import { UiIconModule } from "../icon/icon.module";
import { UiDrawerContentDirective } from "./directives/drawer-content.directive";
import { UiDrawerExtraDirective } from "./directives/drawer-extra.directive";
import { UiDrawerSidePanelDirective } from "./directives/drawer-side-panel.directive";
import { UiDrawerTitleDirective } from "./directives/drawer-title.directive";
import { UiDrawerComponent } from "./drawer.component";
import { UiDrawerService } from "./services/drawer.service";

@NgModule({
  imports: [CommonModule, PortalModule, BidiModule, NzOutletModule, NzNoAnimationModule, UiIconModule, UiAccessibilityModule, LocalizationModule],
  declarations: [UiDrawerComponent, UiDrawerContentDirective, UiDrawerTitleDirective, UiDrawerExtraDirective, UiDrawerSidePanelDirective],
  exports: [UiDrawerComponent, UiDrawerTitleDirective, UiDrawerExtraDirective, UiDrawerSidePanelDirective],
  providers: [UiDrawerService],
})
export class UiDrawerModule {}
